var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"14","height":"10","viewBox":"0 0 16 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1.72308 13.5532L0 12.0936L11.8154 2.08511H1.23077V0H16V12.5107H13.5385V3.54468L1.72308 13.5532Z","fill":"black"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }